/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type SendEnterpriseAdminOnboardingEmailResult = {
  /**
   * Number of recipients the email was dispatched to.
   */
  sentCount: number;
  /**
   * The setup link embedded in the dispatched email.
   */
  setupLink: string;
};

/** @internal */
export const SendEnterpriseAdminOnboardingEmailResult$inboundSchema:
  z.ZodMiniType<SendEnterpriseAdminOnboardingEmailResult, unknown> = z.pipe(
    z.object({
      sent_count: z.int(),
      setup_link: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        "sent_count": "sentCount",
        "setup_link": "setupLink",
      });
    }),
  );

export function sendEnterpriseAdminOnboardingEmailResultFromJSON(
  jsonString: string,
): SafeParseResult<
  SendEnterpriseAdminOnboardingEmailResult,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      SendEnterpriseAdminOnboardingEmailResult$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'SendEnterpriseAdminOnboardingEmailResult' from JSON`,
  );
}
